import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import LoadingSpinner from "../LoadingSpinner";
import { useState } from "react";
import { TutorialVideoDialogProps } from "./types";

export const TutorialVideoDialog = ({
  tutorialLink,
  tutorialTitle,
  title,
  description,
  confirmButtonText,
  cancelButtonText,
  onConfirm,
  onCancel,
  isOpen,
}: TutorialVideoDialogProps) => {
  const [isIframeLoading, setIsIframeLoading] = useState(true);

  return (
    <Dialog open={isOpen} onOpenChange={onCancel}>
      <DialogContent>
        <div className="flex flex-col gap-4">
          <DialogHeader>{title}</DialogHeader>
          <DialogDescription className="whitespace-pre-wrap">
            {description}
          </DialogDescription>
          <div className="flex flex-col gap-2 overflow-hidden rounded-lg">
            <div
              style={{
                position: "relative",
                paddingBottom: "65.9919028340081%",
                height: 0,
              }}
            >
              {isIframeLoading && (
                <div className="absolute inset-0 flex items-center justify-center bg-gray-50">
                  <LoadingSpinner size={4} />
                </div>
              )}
              <iframe
                src={tutorialLink}
                title={tutorialTitle}
                loading="lazy"
                allowFullScreen
                onLoad={() => setIsIframeLoading(false)}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                }}
              />
            </div>
          </div>
        </div>
        <DialogFooter>
          {cancelButtonText && (
            <Button variant="ghost" onClick={onCancel}>
              {cancelButtonText}
            </Button>
          )}
          <Button onClick={onConfirm}>{confirmButtonText}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
